<template>
  <div id="aboutPage">
    <topnav></topnav>

    <div class="aboutHero wideFrame">
      <div class="heroSubtitle">
        On a Mission to
      </div>
      <div class="heroTitle">Fuel Tech Growth
      </div>
      <div class="heroText">
        Sela Provides cloud services and AI solutions for startups & SaaS companies. With an armada of top-notch Cloud
        Architects, DevOps Engineers, Software Developers, FinOps experts, and professional consultants, we help our
        customers scale, grow and win.
      </div>
      <img class="cloud3partners" src="../assets/cloud3partners.svg" />
      <img class="hotAirBalloon" src="../assets/about/blackHotAirBalloon.svg" />
      <img class="stars1" src="../assets/about/stars1.svg" />
      <img class="stars2" src="../assets/about/stars2.svg" />
    </div>


    <div class="ourMission mobileMargins">
      <img class="ourMissionImg" src="../assets/about/aboutHero.jpg" />
      <div class="missionSubtitle">Our Mission</div>

      <div class="missionTitle">To enable the growth of startups and tech companies through innovative cloud and AI
        solutions.</div>
    </div>


    <div class="whyPartner">
      <div class="partnerContainer narrowStrip mobileMargins">
        <div class="partnerContent">
          <div class="whyPartnerTitle">
            Why partner with Sela?
          </div>
          <div class="whyPartnerText">
            Cloud providers offer a powerful engine for your growth. Partnering with Sela provides ongoing technological
            and
            commercial add-ons to that engine, maximizing its performance while reducing costs – so you can grow faster
            and
            more efficiently.
          </div>
        </div>
        <div class="partnerImgContainer">
          <img class="partnerImgRobot" src="../assets/robotFliesSolo.svg" />
          <img class="partnerImg" src="../assets/about/partnerImage.jpg" />
        </div>
      </div>
    </div>

    <div class="whatMakes narrowStri mobileMargins">
      <div class="whatMakesTitle">
        What Makes Us Unique?
      </div>
      <div class="whatMakesBoxes">
        <div class="whatMakesBox">
          <img src="../assets/about/unique1.svg" />
          <div class="whatMakesBoxTitle">Multi-Cloud Trusted Advisor</div>
          <div class="whatMakesBoxText">Sela is at the top partnership level with AWS, Microsoft Azure and Google Cloud,
            allowing us to serve as a multi-cloud trusted advisor.</div>
        </div>

        <div class="whatMakesBox">
          <img src="../assets/about/unique2.svg" />
          <div class="whatMakesBoxTitle">Proven Track Record</div>
          <div class="whatMakesBoxText">With over 30 years of experience and thousands of satisfied customers, you can
            trust us to support you throughout your growth journey.</div>
        </div>

        <div class="whatMakesBox">
          <img src="../assets/about/unique3.svg" />
          <div class="whatMakesBoxTitle">We got what YOU need</div>
          <div class="whatMakesBoxText">We specialize in working specifically with SaaS companies, Startups & Scaleups.
            If you are a digital native company - you’re in the right place.</div>
        </div>

        <div class="whatMakesBox">
          <img src="../assets/about/unique4.svg" />
          <div class="whatMakesBoxTitle">Proactive Customer Engagement</div>
          <div class="whatMakesBoxText">Our team will constantly look for ways to support your growth, through periodic
            architecture reviews, environment technological improvements, GTM support, skilling, and more.</div>
        </div>
      </div>

    </div>

    <div class="selaMap">
      <div class="selaMapBorder wideFrame">
        <div class="selaMapContainer narrowStrip">

          <div class="mapTitle"><span style="font-weight:600">Sela operates in a multi-region capacity</span>, with a
            global presence in New York, California, Pennsylvania, Tel Aviv, Bangalore, Pune, and Mumbai.
          </div>

          <img src="../assets/about/selaMap.svg" />
        </div>
      </div>
    </div>





    <div class="leadership">
      <h2 class="leadTitle">Leadership you can trust</h2>
      <div class="leaders">
        <div class="leaderCard" v-for="(leader, idx) in leaders" :key="idx">
          <div class="leaderAvatar">
            <img :src="leader.imagepath" :alt="leader.name" />
          </div>
          <div class="leaderInfo">
            <div class="leaderName">{{ leader.name }}</div>
            <div class="leaderTitle">{{ leader.jobTitle }}</div>
            <a v-if="leader.linkedinUrl" :href="leader.linkedinUrl" target="_blank" rel="noopener"
              class="leaderLink"><img src="../assets/about/linkedin.svg"></a>
          </div>
        </div>
      </div>
    </div>

    <div class="clients">
      <Logos></Logos>
    </div>


    <div class="contactStrip">
      <div class="contactFormContainer narrowStrip mobileMargins">
        <div class="formText">
          Find out how Sela can help you scale, grow & win
        </div>

        <div class="formContainer">
          <form class="form aboutFormWrap" @submit.prevent="sendForm" v-if="formStatus != 'success'" ref="contactForm"
            id="contactForm">
            <div class="inputPair">
              <input-field class="input land-input aboutInput" label="First Name" :required="true"
                v-model="form.fullName" @error-message="onError" :validationType="ValidationTypeEnum.AlphaBet"
                errorText="First name can only contain letters" />
              <input-field class="input land-input aboutInput" label="Last Name" :required="true"
                v-model="form.lastName" @error-message="onError" :validationType="ValidationTypeEnum.AlphaBet"
                errorText="Last name can only contain letters" />
            </div>
            <input-field class="input land-input aboutInput" type="email" label="Business Email" :required="true"
              v-model="form.email" @error-message="onError" :validationType="ValidationTypeEnum.Email"
              errorText="Invalid Email address" />
            <input-field class="input land-input aboutInput" label="Phone Number" :required="true" v-model="form.phone"
              @error-message="onError" :validationType="ValidationTypeEnum.Phone" errorText="Invalid phone number" />
            <input-field class="input land-input aboutInput" label="Company" :required="true" v-model="form.company"
              @error-message="onError" :validationType="ValidationTypeEnum.Required" errorText="Company is required" />

            <button :disabled="formStatus === 'sending' || this.hasFalseProp" type="submit"
              class="button whiteBorderButton fullWidthButton">
              Get Started Now
            </button>

            <label class="finePrint">
              * By submitting this form, I agree to Sela's Privacy Policy.
            </label>


            <div class="error" v-if="formStatus == 'fail'">
              <p>An error occurred while submitting the form</p>
            </div>
          </form>
          <div class="thanks" v-if="formStatus == 'success'">
            <p>
              <span class="thanksText">Thank you!</span> <br />Your submission has
              been received and our team will contact you shortly
            </p>
          </div>
        </div>

        <img class="robotFront" src="../assets/about/robotFront.svg" />
      </div>

    </div>

    <botfooter></botfooter>
  </div>
</template>

<script>
import Botfooter from "@/components/Botfooter.vue";
import Topnav from "@/components/Topnav.vue";
import { buildPath } from "@/utils/buildPath";
import { getMetatitle, getMetadesc } from "@/utils/getMetadata";
import ronImg from '@/assets/about/ron.jpg';
import eladImg from '@/assets/about/elad.jpg';
import ishaiImg from '@/assets/about/ishai.jpg';
import doronImg from '@/assets/about/doron.jpg';
import shmulikImg from '@/assets/about/shmulik.jpg';
import assafImg from '@/assets/about/assaf.jpg';
import evanImg from '@/assets/about/evan.jpg';
import rishiImg from '@/assets/about/rishi.jpg';
import carmitImg from '@/assets/about/carmit.webp';
import odedImg from '@/assets/about/oded.jpg';
import oritImg from '@/assets/about/orit.jpg';
import axios from 'axios';
import Logos from "@/components/Logos.vue";

export default {
  props: {
    country: String
  },
  metaInfo() {
    return {
      ssrAppId: "sela",
      ...this.seo({
        title: getMetatitle("about"),
        description: getMetadesc("about")
      })
    };
  },
  components: {
    Topnav,
    Botfooter,
    Logos,

  },

  methods: {
    buildPath,
    onError(errorObj) {
      this.formErrors[errorObj.label] = errorObj.validation;

      this.setFalseProp();
    },
    async sendForm() {
      try {
        this.setFalseProp();
        if (this.hasFalseProp) {
          return; // Stop the form submission if there are errors
        }
        this.formStatus = "sending";
        this.form.sourcePage = "about page";
        let utm_source = sessionStorage.getItem('utm_source');
        if (utm_source)
          this.form.utmsource = utm_source;

        await axios.post(
          'https://selagroup.com/.netlify/functions/submitFormDetails',
          this.form
        );
        // await axios.post(
        //   'http://localhost:8888/.netlify/functions/submitFormDetails',
        //   this.form
        // );


        // -----------------------------------------------------


        try {
          this.template = '63f34bf297e6f78495e10b19';  // contact us page template
          //await this.$db.collection("contact").post(this.form);

          // await axios.post(
          //     '/.netlify/functions/send-email?template=' + this.template,
          //     { item: this.form }
          // );

          this.formStatus = "success";
          // if (!this.template)
          //     this.$router.push(this.buildPath(`/contact/thank-you`));
          // else {
          //     if (this.thankYou)
          //         this.$router.push(this.buildPath('/' + this.thankYou));
          // }
        } catch (err) {
          console.log(err);
          this.formStatus = "fail";
        }

        // --------------------------------------------

        this.formStatus = "success";
      } catch (err) {
        console.log(err.response.data);
        this.formStatus = "fail";
      }
    },
    setFalseProp() {
      this.hasFalseProp = Object.values(this.formErrors).includes(false);
    },
    replaceUrlInThankyouText(htmlContent) {
      htmlContent = htmlContent.replace(/@FILE_URL@/g, this.lp.pDFForDownload.imageURL);
      console.log(htmlContent);
      return htmlContent;
    }
  },

  data: () => ({
    tab: 1,
    formStatus: "",
    form: {
      pageName: "",
      pageId: "",
      fullName: "",
      lastName: "",
      email: "",
      company: "",
      phone: "",
      jobTitle: "",
      region: ""
    },
    checkboxChecked: false,
    ValidationTypeEnum: {
      AlphaBet: /^[a-zA-Z ]+$/,
      Email: /^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/,
      Phone: /^(\+)?(?:[0-9-()/.\s?]){6,15}[0-9]{1}$/,
      Required: /.+/
    },
    hasFalseProp: false,
    formErrors: {},
    leaders: [
      {
        name: 'Ron Sprinzak',
        jobTitle: 'CEO',
        imagepath: ronImg,
        linkedinUrl: 'https://www.linkedin.com/in/ron-sprinzak-24a2193/'
      },
      {
        name: 'Elad Nardi',
        jobTitle: 'CRO',
        imagepath: eladImg,
        linkedinUrl: 'https://www.linkedin.com/in/elad-nardi-42241ab7/'
      },
      {
        name: 'Ishai Ram',
        jobTitle: 'EVP Cloud',
        imagepath: ishaiImg,
        linkedinUrl: 'https://www.linkedin.com/in/ishairam/'
      },
      {
        name: 'Doron Aaronsohn',
        jobTitle: 'CMO',
        imagepath: doronImg,
        linkedinUrl: 'https://www.linkedin.com/in/doron-aaronsohn-2912479/'
      },
      {
        name: 'Shmulik Segal',
        jobTitle: 'VP Cloud, AWS',
        imagepath: shmulikImg,
        linkedinUrl: 'https://www.linkedin.com/in/shmuliksegal/'
      },
      {
        name: 'Assaf Jacoby',
        jobTitle: 'VP Cloud, Microsoft Azure',
        imagepath: assafImg,
        linkedinUrl: 'https://www.linkedin.com/in/assafjacoby/'
      },
      {
        name: 'Evan Spaeder',
        jobTitle: 'General Manager, US',
        imagepath: evanImg,
        linkedinUrl: 'https://www.linkedin.com/in/espaeder/'
      },
      {
        name: 'Rishi Ranjan',
        jobTitle: 'General Manager, India',
        imagepath: rishiImg,
        linkedinUrl: 'https://www.linkedin.com/in/rishibranjan/'
      },
      {
        name: 'Carmit Shiffer',
        jobTitle: 'VP HR',
        imagepath: carmitImg,
        linkedinUrl: 'https://www.linkedin.com/in/carmit-shiffer-a4090524/'
      },
      {
        name: 'Oded Frank',
        jobTitle: 'CFO',
        imagepath: odedImg,
        linkedinUrl: 'https://www.linkedin.com/in/oded-frank-b09bba15/'
      }
      ,
      {
        name: 'Orit Elmelech',
        jobTitle: 'VP Professional Services',
        imagepath: oritImg,
        linkedinUrl: 'https://www.linkedin.com/in/orit-elmelech-880a2511b/'
      }
    ],
  }),
  name: "About",
};
</script>

<style scoped>
#aboutPage {
  --darkBg: #1D1C1A;
  font-family: "Lexend";
  --light-blue: #00dbe9;
  --dark-blue: #3894FF;
  --light-gray: #F8F8F8;

}

img {
  width: unset;
  max-width: unset;
}

.wideFrame {
  max-width: 1390px;
  border-radius: 35px;
}

.aboutHero {
  width: 100%;
  background-color: var(--darkBg);
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  margin-top: 30px;
  padding-bottom: 130px;
  padding-top: 100px;
}

.heroTitle {
  font-size: 57px;
  color: white;
  font-weight: 400;
  line-height: 1;
  margin-bottom: 40px;
}

.heroSubtitle {
  font-size: 40px;
  color: var(--light-blue);
  font-weight: 400;
}

.heroText {
  font-size: 18px;
  color: white;
  font-weight: 300;
  max-width: 810px;
  text-align: center;
}

.cloud3partners {
  margin-top: 40px;
  margin-bottom: 40px;
}

.hotAirBalloon {
  position: absolute;
  right: -15px;
  top: 40px;
}

.stars1 {
  position: absolute;
  right: 340px;
  top: 90px;
}

.stars2 {
  position: absolute;
  left: 160px;
  bottom: 200px;
}

/* -------------------------------------- */

.ourMission {
  position: relative;
  width: 100%;
  flex-direction: column;
  align-items: center;
  max-width: 1160px;
  margin: auto;
}

.ourMissionImg {
  position: relative;
  top: -100px;
  left: auto;
  max-width: 1150px;
  border-radius: 30px;
  border: 1px solid white;
}

.missionSubtitle {
  color: var(--dark-blue);
  font-size: 30px;
  font-weight: 600;
  margin-top: 60px;
}

.missionSubtitle::after {
  content: url(../assets/about/star.svg);
  position: relative;
  top: -18px;
}

.missionTitle {
  font-size: 60px;
  line-height: 70px;
  font-weight: 200;
  margin-top: 10px;
}

/* -------------------------------------- */


.narrowStrip {
  max-width: 1160px;
}

.partnerContainer {
  margin: auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-top: 100px;
  padding-bottom: 100px;
}

.whyPartner {
  width: 100%;
  margin-top: 100px;
  background-color: var(--light-gray);
}

.partnerContent {
  flex: 0 0 50%;
}

.whyPartnerTitle {
  font-size: 40px;
  line-height: 40px;
  font-weight: 300;
  margin-bottom: 30px;
}

.whyPartnerText {
  font-size: 18px;
  font-weight: 300;
  padding-right: 100px;
}

.partnerImgContainer {
  display: flex;
  justify-content: end;
  position: relative;
  flex: 0 1 40%;
}

.partnerImgRobot {
  position: relative;
  bottom: -110px;
  left: 85px;
}

.partnerImg {
  max-width: 515px;
    border-radius: 30px;
}

/* ---------------------------------------------- */

.whatMakes {
  padding-top: 100px;
  padding-bottom: 100px;
  margin: auto;
}

.whatMakesTitle {
  font-size: 50px;
  line-height: 80px;
  font-weight: 600;
  padding-bottom: 30px;
  margin: auto;
  text-align: center;
}

.whatMakesBoxes {
  display: flex;
  gap: 10px;
  flex-direction: row;
  flex-wrap: wrap;
  max-width: 920px;
  margin: auto;
}


.whatMakesBox {
  background-color: var(--light-gray);
  border-radius: 15px;
  flex: 0 0 calc(50% - 10px);
  padding: 30px 35px;
}

.whatMakesBoxTitle {
  font-size: 23px;
  font-weight: 400;
  padding-top: 8px;
  padding-bottom: 8px;
}

.whatMakesBoxText {
  font-size: 16px;
  font-weight: 300;
}


/* ------------------------------------------------ */

.selaMap {
  width: 100%;
  background-color: var(--darkBg);
  padding: 50px 20px;
}

.selaMapBorder {
  border: 1px solid white;
  margin: auto;
  padding-top: 80px;
  padding-bottom: 40px;
}

.selaMapContainer {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: auto;
  gap: 30px;
  overflow: hidden;
}

.mapTitle {
  font-size: 30px;
  font-weight: 200;
  color: white;
  text-align: center;
}




/* ------------------------------------------------------- */


.leadership {
  width: 100%;
  margin-top: 70px;
  margin-bottom: 100px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.leadTitle {
  font-size: 40px;
  font-weight: 300;
}

.leaders {
  display: flex;
  gap: 30px;
  flex-wrap: wrap;
  justify-content: center;
  width: 100%;
  max-width: 700px;
}

.leaderCard {
  flex: 0 0 30%;
  background-color: var(--light-gray);
  border-radius: 16px;
  font-size: 17px;
  font-weight: 400;
  display: flex;
  flex-direction: column;

  padding: 15px;
}


.leaderInfo {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.LeaderName {
  color: black;
}

.leaderTitle {
  color: #75716C;
  max-width: 150px;
  text-align: center;
  line-height: 20px;
}

.leaderAvatar {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
}

.leaderAvatar img {
  border-radius: 100%;
  margin-bottom: 15px;
  height: 100px;
  width: 100px;
  object-fit: cover;
}

.leaderLink img {
  width: 20px;
  height: 20px;
  margin-top: 10px;
}

.leaderLink {
  align-self: flex-end;
}

/* ------------------------------------------------------ */



.clients {
  background-color: var(--light-gray);
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  padding: 50px 30px;
  flex-wrap: wrap;
  gap: 18px;
  overflow: hidden;
}



/* ------------------------------------------------------ */

.aboutFormWrap {
  width: 100%;
  max-width: 500px;
  display: flex;
  flex-direction: column;
}

.aboutInput {
  border: 1px solid #818181;
  border-radius: 5px;
  margin-bottom: 20px;
}



.inputPair {
  display: flex;
  flex-direction: row;
  gap: 20px;
}

.contactStrip {
  width: 100%;
  padding-top: 80px;
  padding-bottom: 80px;
}

.contactFormContainer {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  margin-bottom: 100px;
  margin: auto;
  position: relative;
}

.formContainer {
  flex: 0 0 40%;
  justify-items: end;
}

.formText {
  font-size: 45px;
  font-weight: 300;
  line-height: 60px;
  max-width: 600px;
}

.finePrint {
  font-size: 10px;
  font-weight: 300;
  text-align: center;
  margin-top: 10px;
}

#aboutPage .thanks {
  max-width: 100%;
  width: 388px
}

.thanksText {
  color: var(--dark-blue);
  text-align: center;
  font-size: 25px;
}


.robotFront {
  position: absolute;
  top: 200px;
  right: -100px;
  z-index: 100;
  pointer-events: none;
}

@media screen and (max-width: 1400px) {
  .ourMissionImg {
    width: 100%;
  }


}

@media screen and (max-width: 1400px) {
  .mobileMargins {
    max-width: 80%;
  }

  .stars1,
  .stars2 {
    display: none;
  }

  .partnerImg {
    max-width: 100%;
  }

  .contactFormContainer {
    flex-direction: column;
  }

  .partnerContainer {
    flex-direction: column;
  }

  .partnerImgRobot {
    position: absolute;
    bottom: -110px;
    left: 36px;
  }

  .aboutHero {
    padding-bottom: 60px;
  }

  .aboutHero {
    max-width: 88%;
  }


  .heroTitle {
    font-size: 40px;
    font-weight: 400;
    line-height: 1;
    text-align: center;
  }

  .heroSubtitle {
    font-size: 22px;
    font-weight: 400;
  }

  .heroText {
    font-size: 14px;
    font-weight: 300;
    max-width: 78%;
  }

  .hotAirBalloon {
    right: -35px;
    top: 0px;
    width: 160px;
  }

  .cloud3partners {
    margin-top: 40px;
    margin-bottom: 40px;
    max-width: 70%;
  }

  .missionSubtitle {
    font-size: 25px;
    font-weight: 600;
    margin-top: 0;
  }

  .missionTitle {
    font-size: 30px;
    line-height: 37px;
    font-weight: 200;
  }

  .ourMissionImg {
    top: -50px;
  }

  .whyPartnerTitle {
    font-size: 35px;
    line-height: 40px;
    font-weight: 300;
  }

  .whyPartnerText {
    font-size: 15px;
    font-weight: 300;
    padding-right: 0;
    padding-bottom: 40px;
  }



  .whatMakesTitle {
    font-size: 35px;
    line-height: 40px;
    font-weight: 600;
  }


  .whatMakesBoxTitle {
    font-size: 18px;
    font-weight: 400;
  }

  .whatMakesBoxText {
    font-size: 15px;
    font-weight: 300;
  }



  .mapTitle {
    font-size: 20px;
    font-weight: 200;
    max-width: 80%;
  }


  .selaMapContainer img {
    max-width: 100%;
  }

  .leaders {
    gap: 15px;
  }

  .leadTitle {
    font-size: 30px;
    font-weight: 300;
    line-height: 40px;
    max-width: 60%;
    text-align: center;
  }

  .leaderCard {
    flex: 0 0 42%;
    font-size: 14px;
    font-weight: 400;
  }



  .contactStrip {
    padding-bottom: 0;
  }

  .aboutFormWrap {
    margin: auto;
    gap: 22px;
  }

  .formContainer {
    width: 100%;
  }

  .formText {
    font-size: 35px;
    font-weight: 300;
    line-height: 35px;
    margin-bottom: 40px;
  }

  .finePrint {
    font-size: 10px;
    font-weight: 300;
  }

  .inputPair {
    display: flex;
    flex-direction: column;
    gap: 22px;
  }

  .aboutInput {
    margin-bottom: 0;
  }

  .robotFront {
    position: relative;
    top: 71px;
    right: -30%;
    z-index: 100;
    width: 130px;
  }
}

@media screen and (max-width: 600px) {
  .whatMakesBox {
    flex: 0 0 100%;
  }

  .partnerImgRobot {
    bottom: -87px;
    left: 7px;
    max-width: 147px;
  }
}
</style>
